

import GlobalDashboardPage from './pages/dashboard/GlobalDashboardPage.js';

import { UserTablePage, GroupTablePage, TicketTablePage, IncidentTablePage } from 'web-mojo/admin';

export async function registerGlobalPages(app) {
    app.registerPage("global/dashboard", GlobalDashboardPage);

    app.registerPage("global/users", UserTablePage, {route: "global/users"});
    app.registerPage("global/groups", GroupTablePage, {route: "global/groups"});
    app.registerPage("global/tickets", TicketTablePage, {route: "global/tickets"});
    app.registerPage("global/incidents", IncidentTablePage, {route: "global/incidents"});

    app.sidebar.addMenu("global", {
        name: "global",
        className: 'sidebar sidebar-light sidebar-global',
        header: '<div class="fs-5 fw-bold text-center pt-3 sidebar-collapse-hide">Global Menu</div>',
        items: [
            {
                text: 'Dashboard',
                route: '?page=global/dashboard',
                icon: 'bi-speedometer2'
            },
            {
                text: 'Users',
                route: '?page=global/users',
                icon: 'bi-people',
                permissions: ["manage_users"]
            },
            {
                text: 'Groups',
                route: '?page=global/groups',
                icon: 'bi-diagram-3',
                permissions: ["manage_groups"]
            },

            {
                text: 'Lock Management',
                icon: 'bi-wrench-adjustable-circle',
                permissions: ["provision_locks"],
                children: [
                    {
                        icon: "bi-lock",
                        text:"Locks",
                        route: "?page=global/access"
                    },
                    {
                        icon: "bi-bezier",
                        text:"Controllers",
                        route: "?page=global/controllers"
                    },
                    {
                        icon: "bi-info-circle-fill",
                        text:"Models",
                        route: "?page=global/models"
                    },
                ]
            },
            {
                text: 'Firmware',
                id: 'nav-global-firmware',
                icon: 'bi-cpu',
                route: '?page=global/firmware/builds',
                // Must match FirmwareBuildsPage permissions exactly — sys. prefix
                // keeps member-level grants from surfacing a page they can't open.
                permissions: ['sys.manage_firmware', 'sys.view_cam_devices', 'sys.manage_cam_devices'],
            },
            {
                text: 'Security',
                route: null,
                icon: 'bi-shield',
                permissions: ["manage_groups"],
                children: [
                    {
                        text: 'Tickets',
                        route: '?page=global/tickets',
                        icon: 'bi-ticket-detailed'
                    },
                    {
                        text: 'Incidents',
                        route: '?page=global/incidents',
                        icon: 'bi-exclamation-triangle'
                    },
                ]
            },
            {
                spacer: true
            },
            {
                text: 'Exit Menu',
                action: 'exit_menu',
                icon: 'bi-arrow-bar-left',
                handler: async (action, event, el) => {
                    if (app.activeGroup) {
                        // Perform actions specific to the active group
                        app.sidebar.showMenuForGroup(app.activeGroup);
                    } else {
                        app.sidebar.showGroupSearch();
                    }
                }
            }
        ]
    });
}
